<div class="tab" [class.active]="isActive">
    <ng-content></ng-content>
</div>